<template>
	<div class="top" :class="scrollType == true ? 'top-bg' : ''">
		<div  v-if="screenSize=='small'" style="display: flex;gap: 10px">
      <img
        :src="!selectType?'../../../static/image/lobby/select.png':'../../../static/image/lobby/close.png'"
        alt="" class="show-select" @click="showMenu">
      <!-- <img
           :src="!producrType?'../../../static/image/lobby/find.png':'../../../static/image/lobby/close.png'"
           alt="" class="show-select" @click="emitProduct"> -->

    </div>
		<div class="flex-center gap8" @click="showLobby" v-if="screenSize!='small'">
        <img class="top-logo" src="../../../static/image/logo2.png" alt=""  />
<!--      <div class="white font600 font36">NECO</div>-->
		</div>

		<div class="flex-box">
			<div class="flex-box">
				<div class="menu-item"  v-if="i.id=='webLink' || screenSize!='small'" v-for="(i,index) in menu" :key="index" @click="menuClick(i)">{{i.text}}
				</div>
        <div class="select select-web" @click.stop="openSelectWeb" @mouseenter="enterChangeWeb" @mouseleave="levelChangeWeb">
          
          <div class="more-text">{{ $t('网页直连') }}</div>
          <transition name="slide-left-to-right">
            <div class="select-val select-val-web" v-if="showDropdownWeb">
              <div class="select-div select-div-web"
                v-for="(item, index) in webList" :key="index" @click.stop="openUrl(item.link)">
                {{ $t(item.text) }}
              </div>
            </div>
          </transition>
        </div>
        <!-- <div v-if="screenSize!=='small'" class="more-text-box"></div> -->
				<div class="downloadBtn font700" @click="openDownload(true)">{{$t('下载')}}
        </div>
				<!-- <img v-if="screenSize!='small'"
					:src="!producrType?'../../../static/image/lobby/find.png':'../../../static/image/lobby/close.png'"
					alt="" class="show-select" @click="emitProduct"> -->
			</div>
			<div class="select" @click.stop="openSelect" @mouseenter="enterChange" @mouseleave="levelChange">
				<img src="../../../static/image/list/lang.png" alt="" />
				<transition name="slide-right-to-left">
					<div class="select-val" v-if="showDropdown">
						<div class="select-div" :class="selectedOption == item.name ? 'select-text' : ''"
							v-for="(item, index) in langList" :key="index" @click.stop="changeDropdown(item)">
							{{ $t(item.text) }}
							<img src="../../../static/image/list/success.png" alt=""
								v-if="selectedOption == item.name" />
						</div>
            
					</div>
				</transition>
			</div>

		</div>

	</div>
</template>

<script>
import {
  formatMobile,
  getDeviceType
} from '../../utils/common'
import {
  mapState
} from 'vuex'
let _this
export default {
  computed: mapState({
    screenSize (state) {
      return state.screenSize
    },
    common (state) {
      return state.common
    }
  }),
  props: {
    showMenuType: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInfo: true,
      selectType:false,
      selectedOption: '',
      imgLogo: '',
      showDropdown: false,
      downloadType:false,
      langList: [{
        name: 'en',

        text: 'English'
      },
      {
        name: 'zh_CN',

        text: '简体中文'
      },
        {
        	name: "ja_JP",
        	text: "日本語"
        },
        {

        	name: "ko_KR",
        	text: "한국인"
        },
      {
        name: 'zh_CHT',
        text: '繁體中文'
      },
        {

        	name: "vi_VN",
        	text: "Việt Nam"
        },

        // {
        // 	name: "es_ES",
        // 	text: "España"
        // },
        {
        	name: "th_TH",
        	text: "ภาษาไทย"
        },
        {
        	name: "ms_MY",
        	text: "Malaysia"
        },
        {
        	name: "pt_BR",
        	text: "Portugal"
        },
        {
          name: "ru_RU",
          text: "Россия"
        }
      ],
      isShow: false,
      scrollType: false,
      menu: [
        // {
        //   text: this.$t('新闻'),
        //   link: '',
        //   news:true
        // },
        {
          text: this.$t('跨链桥'),
          link:'https://neco.novaichain.com/#/'
        },
        {
          text: this.$t('SWAP交易'),
          link: 'https://swap.novaichain.com'
        },
        {
          text: this.$t('铸造与销毁协议'),
          link: 'https://tab.neco.ltd/#/'
        },
        // {
        //   id: 'webLink',
        //   text: this.$t('网页直连'),
        //   link: 'https://web.neco.ltd/'
        // },
        
      ],
      // webList: [
      //   {
      //     text: this.$t('跨链桥'),
      //     link:'https://neco.novaichain.com/#/'
      //   },
      //   {
      //     text: this.$t('SWAP交易'),
      //     link: 'https://swap.novaichain.com'
      //   },
      //   {
      //     text: this.$t('铸造与销毁协议'),
      //     link: 'https://tab.neco.ltd/#/'
      //   }
      // ],
      webList: [
        {
          text: this.$t('全球版'),
          link:'https://web.neco.ltd/'
        },
        {
          text: this.$t('中国版'),
          link: 'https://cn.neco.ltd'
        }
      ],
      producrType: false,
      showDropdownWeb: false,
    }
  },
  watch: {
    showMenuType (val) {
      this.selectType = val
    }
  },
  mounted () {
    let type = getDeviceType()
    if (type === 'pc') {
      this.menu = this.menu.map(item => {
        if (item.id === 'webLink') {
          item.link = 'https://pc.neco.ltd/#/'
        }
        return item
      })
    } else {
      this.menu = this.menu.map(item => {
        if (item.id === 'webLink') {
          item.link = 'https://web.neco.ltd/'
        }
        return item
      })
    }
    window.addEventListener('scroll', this.handleScroll)
    this.selectedOption = localStorage.getItem('locale')
      ? localStorage.getItem('locale')
      : 'en'
    console.log(this.selectedOption)
    this.$watch(
      'selectedOption',
      (newValue, oldValue) => {
        location.reload()
      }, {
        deep: true
      }
    )
    document.addEventListener('click', this.HiddenClick)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.HiddenClick, true)
  },
  methods: {
    noOpen () {
      this.$toast(this.$t('noOpen'))
    },
    showLobby(){
     window.location.reload()
    },
    menuClick(i){
      if(i.link){
        let link = i.link
        if (i.id === 'webLink') {
          let lang = localStorage.getItem('locale')
          let list = ['zh_CN', 'en_US', 'vi_VN', 'ko_KR', 'ru_RU']
          if (!list.includes(lang)) {
            lang = 'en-US'
          }
          lang = lang.replace('_', '-')
          link = link + '?lang=' + lang
        }
        
        window.open(link)
      }else if(i.news){
        this.emitNews()
      }
    },
    emitProduct () {
      this.producrType = !this.producrType
      this.selectType=false
      this.$emit('emitProduct', this.producrType)
      this.$emit('selectType', this.selectType)
      this.$emit('openDownload',false)
    },
    showMenu(){
      this.selectType=!this.selectType
      this.producrType=false
      this.$emit('emitProduct', this.producrType)
      this.$emit('selectType', this.selectType)
      this.$emit('openDownload')
    },
    openDownload(type){
      console.log('位置',type)
      // this.$emit('emitProduct', false)
      // this.$emit('selectType', false)
      // this.$emit('openDownload',type)
      // window.scrollTo(0, document.body.scrollHeight);
      document.getElementsByClassName('box-content')[0].scrollIntoView(false, 'smooth');
    },
    formatMobile,
    scrollToSection (sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition - (window.innerHeight / 2 - element.offsetHeight / 2)

        window.scrollTo({
          top: window.scrollY + offsetPosition,
          behavior: 'smooth'
        })
      }
    },

    openSelect () {
      if (this.screenSize === 'small') {
        this.showDropdown = !this.showDropdown
        if (this.showDropdown) {
          this.showDropdownWeb = false
        }
      }
    },
    enterChange () {
      if (this.screenSize !== 'small') {
        this.showDropdown = true
        this.showDropdownWeb = false
      }
    },
    levelChange () {
      if (this.screenSize !== 'small') {
        this.showDropdown = false
      }
    },
    changeDropdown (item) {
      this.selectedOption = item.name
      localStorage.setItem('locale', this.selectedOption)
      this.showDropdown = false
      this.$forceUpdate()
    },
    isShowdata () {
      this.isShow = !this.isShow
    },
    HiddenClick: function () {
      this.showDropdown = false
      this.isShow = false
    },
    handleScroll () {
      const scrollDistance = window.pageYOffset
      if (scrollDistance > 0) {
        this.scrollType = true
      } else {
        this.scrollType = false
      }
    },
    emitDownlaod () {
      window.open(process.env.android)
    },
    emitDownlaodIos () {
      window.open(process.env.ios)
    },
    emitNews () {
      this.$emit('emitNews')
    },
    openUrl(url) {
      window.open(url)
    },
    openSelectWeb() {
      if (this.screenSize === 'small') {
        this.showDropdownWeb = !this.showDropdownWeb
        if (this.showDropdownWeb) {
          this.showDropdown = false
        }
      }
    },
    enterChangeWeb () {
      if (this.screenSize !== 'small') {
        this.showDropdownWeb = true
        this.showDropdown = false
      }
    },
    levelChangeWeb () {
      if (this.screenSize !== 'small') {
        this.showDropdownWeb = false
      }
    },
  }
}
</script>

<style scoped>
	.top-bg {
		/* 		width: 100%;
		height: 100%;
		background: #000;
		backdrop-filter: blur(10px); */
	}

	.slide-right-to-left-enter-active,
	.slide-right-to-left-leave-active {
		transition: transform 0.3s linear, opacity 0.3s linear;
		/* 设置过渡动画的持续时间和缓动效果 */
	}

	.slide-right-to-left-enter,
	.slide-right-to-left-leave-to {
		transform: scale(0);
		/* 初始状态在容器右侧之外 */
		opacity: 0;
		/* 初始透明度为0，隐藏内容 */
	}
  .logo-box{
    width: 11rem;
    height: .56rem;
    border-radius: 20px;
    /*background: #FFF;*/
    display: flex;
    align-items: center;
    justify-content: center;

  }

	@media screen and (max-width: 768px) {
		.top {

			min-width: calc(100% - 40px) !important;
			padding: 0 20px !important;

		}

		.downloadBtn {
			background-color: rgba(255,255,255,.16) !important;
			color: #fff !important;
      font-size: 12px!important;
			padding: .16rem .32rem !important;
      position: relative;
		}

		.select img {
			width: 25px !important;
			height: 25px !important;
			border-radius: 50%;
			cursor: pointer;
		}

    .select .more-img {
      border-radius: 0;
    }

		.select-val {
			width: 1.6rem !important;
			padding: .2rem .3rem !important;
      z-index: 10;
		}

    .select-val-web {
      right: 32px !important;
      text-align: center;
      width: max-content !important;
      /* transform: translateX(0) !important; */
      top: 55px !important;
      /* animation: identifier1 0.3s ease-in-out !important; */
    }
    @keyframes identifier1 {
      from {
        transform: translateX(0) scale(0.1);
      }
      to {
        transform: translateX(0) scale(1);
      }
    }

		.select-div {
			height: .7rem !important;
			font-size: .3rem !important;
		}
    .select-div-web {
      justify-content: center;
      height: auto !important;
      font-size: 16px !important;
    }
    .show-select {
      width: 30px!important;
      height: 30px!important;
      cursor: pointer;
    }
    .menu-box{
      display: flex;
      flex-direction: column;
      width: calc(100vw - .32rem);
      padding: 0 .16rem;
      position: fixed;
      top: 100px;
    }
    .menu-title{
      font-size: 32px;
      color: #fff;
    }
    .download-box{
      width: fit-content;
      padding: 10px!important;;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.10);
      position: absolute;
      top: 45px;
      left: 0;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .download-item{
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 12px!important;
      color: rgba(255,255,255,0.65);
    }
    .download-item img{
      width: 10px!important;
      height: 10px!important;
    }
    /* .menu-item-web {
      font-size: 14px !important;
    } */
	}

	/* 	@media screen and (max-width: 960px) {
		.top {
			width: calc(100% - 80px) !important;
			padding: 0 40px !important;
		}

		.select-val {
			right: 25px !important;
		}
	} */

	.flex-box {
		display: flex;
		align-items: center;
		height: 100%;
		gap: .19rem;
	}

	.top {
		height: 100px;
		/* overflow: hidden; */
		z-index: 100;
		background: none;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: calc(100% - 128px);
		padding: 0 64px;
		position: fixed;
		top: 0;
		left: 0;
		min-width: 1200px;

	}

	.top-logo {
		width: 136px;
		height: 61px;
		cursor: pointer;
	}

	.menu-item {
		font-size: 16px;
		color: #fff;
		cursor: pointer;
		font-weight: 400;
    margin-right: .3rem;
    text-align: right;
	}

	.top-list {
		display: flex;
		align-items: center;
		/*width: 5rem;*/
		justify-content: space-between;
		/*margin-right: 2.1rem;*/
		position: relative;
		gap: 15px;
		/* font-size: 0.1rem; */
	}

	.top-list div {
		color: rgba(255, 255, 255, 0.9);
		font-size: 16px;
		cursor: pointer;
	}

	top-list div:hover {}

	.select-div {
		cursor: pointer;
		display: flex;
		height: .4rem;
		justify-content: space-between;
		align-items: center;
		color: rgba(255, 255, 255, 0.6);
	}
  .select-div-web {
    justify-content: center;
    height: auto;
    margin-bottom: 0.2rem;
  }

	.select-div :hover {
		color: rgba(255, 255, 255, 1);
	}

	.select-div img {
		width: 0.2rem !important;
		height: 0.12rem !important;

	}

	.select-val {
		position: absolute;
		width: 1.06rem;
		padding: 0.18rem 0.12rem 0 0.12rem;
		top: 75px;
		right: 23px;
		color: #ffffff;
		z-index: 100;
		border-radius: 0.06rem;
		text-align: center;
		background-color: rgba(0,0,0,.6);

	}
  .select-val-web {
    right: 50%;
    transform: translateX(50%);
    text-align: center;
    width: max-content !important;
    top: 140px;
    animation: identifier 0.3s ease-in-out;
  }

  @keyframes identifier {
    from {
      transform: translateX(50%) scale(0.1);
    }
    to {
      transform: translateX(50%) scale(1);
    }
  }

	.select {
		/* margin-left: 15px; */
		/*width: 1.06rem;*/
		height: 1.5rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

  .select-web {
    position: relative;
  }

	.wallet {
		width: 20px !important;
		height: 20px !important;
		cursor: pointer;
		filter: brightness(100);
	}

	.select img {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		cursor: pointer;
	}

  .select .more-img {
    border-radius: 0;
  }

  .more-text {
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    font-weight: 400;
  }

  .more-text-box {
    padding-right: .3rem;
  }

	.downloadBtn {
		padding: .08rem .36rem;
		color: #fff;
		font-size: 16px;
		font-style: normal;
		line-height: normal;
		border-radius: .24rem;
		background: rgba(255,255,255,.16);
		cursor: pointer;
    position: relative;
	}

	.show-select {
		width: 40px;
		height: 40px;
		cursor: pointer;
	}

	.select-text {
		color: #fff !important;

	}
  .download-box{
    padding: 20px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.10);
    position: absolute;
    top: 45px;
    left: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .download-item{
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: .16rem;
    color: rgba(255,255,255,0.65);
  }
  .download-item img{
    width: 20px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/top.vue